import React, { useContext } from 'react';
import { string, bool, func, number } from 'prop-types';
import { DeliveryOptions } from '@thd-olt-component-react/delivery-options';
import { TileHead } from '../TileHead';
import { TileFooter } from '../TileFooter';
import { FulfillmentContext } from '../../FulfillmentContext';

const OffshoreSthUnavailable = ({
  itemId,
  quantity,
  stateName
}) => {

  const {
    setShowCheckAvailability
  } = useContext(FulfillmentContext);

  const handleOnClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setShowCheckAvailability(true);
  };

  return (
    <>
      <div className="u__center">
        <TileHead
          title="Ship to Home"
          icon="pick-up-false"
        />
        <div className="warning_text">Not available in {stateName}</div>
      </div>
      <TileFooter>
        <button type="button" className="u__default-link" onClick={handleOnClick}>
          Change Zip
        </button>
      </TileFooter>
    </>
  );
};
OffshoreSthUnavailable.propTypes = {
  itemId: string.isRequired,
  quantity: number,
  stateName: string
};
OffshoreSthUnavailable.defaultProps = {
  stateName: null,
  quantity: 1
};

export { OffshoreSthUnavailable };
